import { render, staticRenderFns } from "./PublishedEventModal.vue?vue&type=template&id=19a4be78&"
import script from "./PublishedEventModal.vue?vue&type=script&lang=js&"
export * from "./PublishedEventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports